import { Component } from '@angular/core';

@Component({
  selector: 'app-row',
  standalone: true,
  imports: [],
  template: `<ng-content></ng-content>`,
  styleUrl: './row.component.scss'
})
export class RowComponent {

}
